import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import React from 'react'
import { Button, Col, Form, Row } from 'antd/lib/index'
import { get } from 'lodash'
import CurrencySelect from '../../../../elements/Select/Currency'
import { DatePicker } from 'antd'
import { dateVal } from '../../../../modules/Utils'

function PayrollForm (props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { payroll, onGenerate, generating, isNew } = props
  return (
    <Form>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="From">
            {getFieldDecorator('company', {
              initialValue: get(payroll, 'company._id'),
              rules: rules.select,
            })(<OrganisationsSelect disabled={!isNew}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Currency">
            {getFieldDecorator('currency', {
              initialValue: get(payroll, 'currency'),
              rules: rules.select,
            })(<CurrencySelect disabled={!isNew}/>)}
          </Form.Item>
        </Col>

        {isNew && (
          <Col offset={4} span={8}>
            <Button
              type={'primary'}
              style={{ marginLeft: '25%' }}
              disabled={!getFieldValue('company') || !getFieldValue('currency')}
              loading={generating}
              onClick={onGenerate}>
              Generate
            </Button>
          </Col>
        )}
      </Row>

      {!isNew && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Start">
              {getFieldDecorator('start', {
                initialValue: dateVal(payroll, 'start'),
                rules: rules.select,
              })(<DatePicker disabled={!isNew}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="End">
              {getFieldDecorator('end', {
                initialValue: dateVal(payroll, 'end'),
                rules: rules.select,
              })(<DatePicker disabled={!isNew}/>)}
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  )
}

PayrollForm.propTypes = {}
PayrollForm.defaultProps = {}

export default Form.create()((PayrollForm))
